module.exports = __webpack_public_path__ + "static/media/report5.86f56f72.xlsx";